import Layout from '../../components/layout/Layout'
import { Link, useLocation } from 'react-router-dom'
import thoughtPosts from '@/data/thoughts/posts.json'

const Thoughts = () => {
  const location = useLocation()
  const showAll = new URLSearchParams(location.search).get('show_all') === '1'
  
  const filteredPosts = showAll 
    ? thoughtPosts.posts 
    : thoughtPosts.posts.filter(post => post.is_public !== false)
  
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-6">
        <h1 className="text-4xl font-bold text-foreground mb-6">
          Thoughts
        </h1>
        <div className="space-y-6 md:space-y-2">
          {filteredPosts.map((post, index) => (
            <article key={index} className="mb-2 md:mb-0">
              <Link 
                to={`${post.slug}${location.search}`}
                className="flex group transition-colors"
              >
                <div className="flex flex-col md:flex-row md:items-center w-full">
                  <div className="flex items-center gap-3 md:gap-0">
                    <div className="w-1.5 h-1.5 rounded-full bg-foreground/60 block md:hidden" />
                    <h2 className="text-lg font-sans tracking-[-0.015em] leading-tight [text-wrap:balance] w-full md:w-auto relative">
                      <span className="relative z-20">
                        {post.title}
                        {!post.is_public && showAll && (
                          <span className="ml-2 text-xs text-muted-foreground">(hidden)</span>
                        )}
                      </span>
                      <span className="absolute inset-0 bg-[#ff9632] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-[0.65,0,0.35,1] z-10" />
                    </h2>
                  </div>
                  <time className="hidden md:block text-muted-foreground text-[0.7rem] ml-3 shrink-0 leading-normal">
                    {post.date}
                  </time>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Thoughts 